import React from 'react';
import { BuilderBlocks } from '@builder.io/react';
import { Carousel as DefaultDSCarousel, CarouselProps as DSCarouselProps } from '@/components/shared';
import { CarouselComponentProps } from './register';

export interface CarouselProps extends CarouselComponentProps {
	readonly DSCarousel?: React.FC<DSCarouselProps>;
}

/**
 * CMS Carousel component, used for displaying content in a carousel.
 * It has support for autoplay, and can be used with or without arrows and dots.
 */
export const Carousel: React.FunctionComponent<CarouselProps> = ({
	slides,
	builderBlock,
	showArrows,
	showArrowsOnMobile,
	showDots,
	gap,
	autoPlay,
	autoPlaySpeed,
	customSlidesWidth,
	DSCarousel = DefaultDSCarousel,
}) => {
	if (!slides) {
		return null;
	}

	return (
		<DSCarousel
			showArrows={showArrows}
			showArrowsOnMobile={showArrowsOnMobile}
			showDots={showDots}
			gap={gap}
			disableAutoplay={!autoPlay}
			autoPlaySpeed={autoPlaySpeed}
			slidesWidth={customSlidesWidth ? `${customSlidesWidth}%` : undefined}
		>
			{slides.map((slide, index) => (
				<BuilderBlocks
					key={index}
					parentElementId={builderBlock && builderBlock.id}
					dataPath={`component.options.slides.${index}.content`}
					child
					blocks={slide.content}
				/>
			))}
		</DSCarousel>
	);
};
